module.exports = __webpack_public_path__ + "img/ysgr.b9d0cc3b.png";